import permissions from '@/enums/permissions';

const liquidationArchivesRouter = [
    {
        path: '/arquivos-liquidacao',
        name: 'liquidation-archives',
        component: () => import('@/views/pages/LiquidationArchives/LiquidationArchives.vue'),
        meta: {

            permissions: permissions.liquidationArchives,
        },
    },
];

export default liquidationArchivesRouter;
